import { useParams, Link } from "react-router-dom";

const CONTENT = {
  terms: {
    title: "How Vorra works & Terms of use",
    body: [
      ["Vorra is a marketplace, not a dealer", "Vorra provides an online platform that connects private sellers and dealers with buyers. Vorra does not own, inspect, sell, or take possession of any vehicle listed. Vorra is not a party to any transaction between a buyer and a seller."],
      ["Seller responsibility", "Sellers are solely and fully responsible for the accuracy of their listings, the condition and roadworthiness of the vehicle, the legality of the sale, and compliance with all applicable laws (including consumer, trading, and distance-selling rules where they apply to dealers)."],
      ["Fees & monetisation", "Vorra charges sellers for access and listing via monthly plans or pay-as-you-go listing fees. Vorra does not take any commission on the sale price. Fees paid are for platform access and are non-refundable once a listing has gone live, including where a listing is removed early."],
      ["Trust labels", "Labels such as 'Verified', 'Pending Review' and 'Mileage Warning' are operational indicators only. They are not a guarantee, warranty or certification of a vehicle's condition, history or value. Buyers must carry out their own checks and inspections."],
      ["Subscriptions", "If a subscription is cancelled or a renewal payment fails, affected live listings are taken offline. Cancelling a plan removes live listings immediately."],
      ["Buyer conduct", "Buyers must not misuse messaging for spam, abuse or fraud. Vorra may mute, block, suspend or remove accounts that breach these terms."],
    ],
  },
  privacy: {
    title: "Privacy",
    body: [
      ["What we store", "We store your account details, listings, uploaded photos and documents, messages, and payment records needed to operate the marketplace."],
      ["V5C documents", "V5C logbook documents you upload are stored in private storage and are only accessible to you and Vorra's review team for verification. They are never shown publicly on a listing."],
      ["Payments", "Payments are processed by Stripe. We do not store full card details on our servers."],
      ["Contact", "Email privacy@vorra.co.uk for any data request."],
    ],
  },
  liability: {
    title: "Platform liability",
    body: [
      ["Intermediary only", "Vorra is an intermediary platform. We are not responsible for the condition, quality, safety, legality or description of any vehicle, nor for the conduct of any buyer or seller."],
      ["No warranty", "Vehicles are sold by the seller, not by Vorra. Any warranty, guarantee or consumer right is between the buyer and the seller. Vorra gives no warranty on any vehicle."],
      ["Disputes & faults", "If a vehicle is later found faulty, the matter is between buyer and seller. Vorra support will point to these marketplace terms and seller responsibility. We do preserve reports to enforce action against repeat offenders."],
      ["Enforcement", "We may freeze accounts and block future publishing where there is a chargeback, fraud, repeated reports, or a private seller operating as an undeclared trader."],
    ],
  },
};

export default function Legal() {
  const { page } = useParams();
  const data = CONTENT[page] || CONTENT.terms;
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <div className="flex gap-3 mb-8 text-sm">
        {Object.keys(CONTENT).map((k) => (
          <Link key={k} to={`/legal/${k}`} className={`capitalize px-3 py-1 rounded-full ${page === k ? "bg-primary text-white" : "bg-muted text-muted-foreground"}`}>{k}</Link>
        ))}
      </div>
      <h1 className="font-heading text-3xl sm:text-4xl font-bold">{data.title}</h1>
      <div className="mt-8 space-y-6">
        {data.body.map(([h, p], i) => (
          <div key={i}><h2 className="font-heading text-lg font-semibold">{h}</h2><p className="text-muted-foreground mt-1 leading-relaxed">{p}</p></div>
        ))}
      </div>
      <div className="mt-10 bg-amber-50 border border-amber-200 rounded-xl p-5 text-sm text-amber-800">
        By using Vorra you accept that Vorra is a marketplace platform only and is not responsible for the vehicle, its condition, or the outcome of any sale.
      </div>
    </div>
  );
}
